import type { Reports } from './types.tsx';

export const extractData = (hasSoftwareAccess: boolean): Reports => ({
	hasTimeTrackingReport: true,
	hasUserWorkloadReport: true,
	hasVersionWorkloadReport: hasSoftwareAccess,
});
